import React from 'react';
import Weather from './Weather';
import './Weather.css';

function App(){
  return(
    <>
     <Weather />
    </>
  )
}

export default App;